<template>
  <div class="input-error-msg" v-html="error"></div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    error: String,
  },
})
export default class ErrorLabel extends Vue {}
</script>

<style lang="scss" scoped>
.input-error-msg {
  font-size: 12px;
  color: var(--error-color);
  line-height: 19px;
}
</style>
